module.exports = __webpack_public_path__ + "static/media/resultsGraphicFailed1_mobile.57396dc6.jpg";